/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pass_NameInputs */

const en_platform_pass_name = /** @type {(inputs: Platform_Pass_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10-session pass`)
};

const pl_platform_pass_name = /** @type {(inputs: Platform_Pass_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karnet 10 wejść`)
};

/**
* | output |
* | --- |
* | "10-session pass" |
*
* @param {Platform_Pass_NameInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pass_name = /** @type {((inputs?: Platform_Pass_NameInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pass_NameInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pass_name(inputs)
	return en_platform_pass_name(inputs)
});